// extracted by mini-css-extract-plugin
module.exports = {"icons":"ActionIcons_icons__1tz0f","icons__button":"ActionIcons_icons__button__3fC76"};